import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Chip,
} from '@material-ui/core';

// Action color mapping
const ACTION_COLORS = {
  BILLING_MASTER_ITEM_CREATED: 'primary',
  BILLING_MASTER_ITEM_UPDATED: 'default',
  BILLING_MASTER_ITEM_APPROVED: 'primary',
  BILLING_MASTER_ITEM_DEACTIVATED: 'secondary',
  BILLING_MASTER_CSV_IMPORTED: 'primary',
  BILLING_OPERATOR_ITEM_CREATED: 'primary',
  BILLING_OPERATOR_ITEM_UPDATED: 'default',
  BILLING_OPERATOR_CSV_IMPORTED: 'primary',
  BILLING_REVIEW_ITEM_RESOLVED: 'primary',
  BILLING_REVIEW_ITEM_DISMISSED: 'secondary',
};

/**
 * Audit Log Tab Component
 * Displays activity logs for billing changes
 */
const AuditLogTab = ({
  classes,
  actionFilter,
  auditFiltered,
  onActionFilterChange,
}) => {
  return (
    <>
      <div className={classes.toolbar}>
        <FormControl size="small" variant="outlined" style={{ minWidth: 220 }}>
          <InputLabel>Filter by action</InputLabel>
          <Select
            value={actionFilter}
            onChange={(e) => onActionFilterChange(e.target.value)}
            label="Filter by action"
          >
            <MenuItem value="ALL">All actions</MenuItem>
            <MenuItem value="BILLING_MASTER_ITEM_CREATED">
              Master Item Created
            </MenuItem>
            <MenuItem value="BILLING_MASTER_ITEM_UPDATED">
              Master Item Updated
            </MenuItem>
            <MenuItem value="BILLING_MASTER_ITEM_APPROVED">
              Master Item Approved
            </MenuItem>
            <MenuItem value="BILLING_MASTER_ITEM_DEACTIVATED">
              Master Item Deactivated
            </MenuItem>
            <MenuItem value="BILLING_MASTER_CSV_IMPORTED">
              Master CSV Imported
            </MenuItem>
            <MenuItem value="BILLING_OPERATOR_ITEM_CREATED">
              Operator Override Created
            </MenuItem>
            <MenuItem value="BILLING_OPERATOR_ITEM_UPDATED">
              Operator Override Updated
            </MenuItem>
            <MenuItem value="BILLING_OPERATOR_CSV_IMPORTED">
              Operator CSV Imported
            </MenuItem>
            <MenuItem value="BILLING_REVIEW_ITEM_RESOLVED">
              Review Item Resolved
            </MenuItem>
            <MenuItem value="BILLING_REVIEW_ITEM_DISMISSED">
              Review Item Dismissed
            </MenuItem>
          </Select>
        </FormControl>
      </div>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Timestamp</TableCell>
              <TableCell>User</TableCell>
              <TableCell>Action</TableCell>
              <TableCell>Resource</TableCell>
              <TableCell>Details</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {auditFiltered.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <Typography color="textSecondary" variant="body2">
                    No activity logs found.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
            {auditFiltered.map((a, i) => (
              <TableRow key={a._id || i} hover>
                <TableCell>
                  <code>{new Date(a.timestamp).toLocaleString()}</code>
                </TableCell>
                <TableCell>{a.actor?.email || '—'}</TableCell>
                <TableCell>
                  <Chip
                    size="small"
                    label={a.action}
                    color={ACTION_COLORS[a.action] || 'default'}
                  />
                </TableCell>
                <TableCell>
                  {a.resource?.displayName || a.resource?.id || '—'}
                </TableCell>
                <TableCell>
                  {a.changes?.length > 0
                    ? a.changes.map((c, j) => (
                      <Typography key={j} variant="caption" display="block">
                        <strong>{c.field}</strong>: {String(c.oldValue)} →{' '}
                        {String(c.newValue)}
                      </Typography>
                    ))
                    : a.metadata
                      ? (
                        <Typography variant="caption">
                          {typeof a.metadata === 'object'
                            ? JSON.stringify(a.metadata)
                            : a.metadata}
                        </Typography>
                      )
                      : '—'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default AuditLogTab;
